export const novelRunsEn = {
  title: 'Novel runs',
  list: {
    filters: { email: 'Player email', emailPlaceholder: 'Search by email', pack: 'Work', packSearch: 'All works (type to search title, slug or creator email)', packSearching: 'Searching…', packEmpty: 'No matching works', packClear: 'Clear work filter', failedOnly: 'Only runs with failed jobs', apply: 'Search' },
    table: { player: 'Player', pack: 'Work', status: 'Status', turns: 'Turns', jobs: 'Background jobs', failedJobs: 'Failed jobs', lastPlayed: 'Last played', actions: 'Actions' },
    statuses: { active: 'Active', archived: 'Archived' },
    jobsPending: 'Pending',
    jobsIdle: 'None',
    unknownUser: 'Unknown player',
    empty: 'No runs match these filters',
    audit: 'Audit',
    filterByPack: 'Show only runs of this work',
    pager: { prev: 'Previous', next: 'Next', pageSize: 'Per page', summary: '{total} runs · page {page} of {pages}' },
  },
  audit: {
    back: 'Runs',
    refresh: 'Refresh',
    empty: 'None',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Copy failed: {message}',
    copyId: 'Copy {id}',
    points: '{points} pts',
    separator: ', ',
    spoilerNotice: 'Spoilers, author view: hidden settings, character knowledge, actual prompts, and model output. Do not share with players.',
    tabs: { overview: 'Overview', characters: 'Characters', timeline: 'Timeline', director: 'Director', story: 'Story', calls: 'Calls', drama: 'Avatar', raw: 'Raw data' },
    bar: {
      turns: 'Turn {count}',
      jobsPending: 'Jobs pending',
      jobsIdle: 'Jobs idle',
      writer: 'Writer {model}',
      writerTitle: 'Performer for this playthrough: {performer}; latest actual model: {model}',
      points: '{points} pts total',
      refreshTitle: 'Last refreshed {time}. Read-only; opening this page makes no model calls.',
      retryFailed: 'Retry failed jobs ({count})',
    },
    overview: { runInfo: 'Run info', player: 'Player', work: 'Work', packageHash: 'Content hash', created: 'Created', lastPlayed: 'Last played', branch: 'Branch' },
    branch: { active: 'active', candidate: 'candidate', option: '{id} · {state} · {turns} turns' },
    scene: {
      title: 'Current scene',
      people: 'Present',
      storyTime: 'Story time',
      items: 'Items here',
      recording: {
        pending: 'Prose is saved; the scene and character knowledge are updating in the background.',
        failed: 'Prose is saved, but background recording failed; retry it from the job list in Calls.',
      },
    },
    request: {
      title: 'Latest request',
      input: 'Input',
      status: 'Status',
      elapsed: 'Elapsed',
      cost: 'Cost',
      stage: 'Stage',
      model: 'Model',
      unrecorded: 'No model stage records were saved for this request; nothing is reconstructed from templates.',
    },
    roles: { performer: 'Writer', structured: 'Structured' },
    time: {
      day: 'Day {day}',
      phases: { morning: 'Morning', afternoon: 'Afternoon', evening: 'Evening', night: 'Night' },
    },
    requestStatuses: { generating: 'Generating', committed: 'Committed', failed: 'Failed', cancelled: 'Cancelled' },
    stageStatuses: { started: 'Started', completed: 'Completed', failed: 'Failed' },
    turns: {
      turn: 'Turn {seq}',
      modes: { mixed: 'Speech and action', speech: 'Speech', action: 'Action', continue: 'Continue' },
      recordingStates: { pending: 'Recording pending', completed: 'Recorded', failed: 'Recording failed' },
    },
    characters: {
      list: 'Characters',
      openCount: '{count} open',
      appearance: 'Appearance',
      identity: 'Identity',
      initialGoal: 'Initial goal',
      latestGoal: 'Latest goal',
      sections: { opening: 'Opening settings', later: 'Later records', witness: 'Witnesses and observations', memory: 'Rolling memory' },
      facts: 'Known facts',
      relations: 'Relationships',
      portrayal: 'Personality and voice',
      personality: 'Personality',
      speechStyle: 'Voice',
      cues: 'Performance cues',
      examples: 'Voice examples (not history)',
      attitude: 'Attitude',
      goals: 'Goals',
      threads: 'Open threads',
      thread: 'Thread',
      witnessed: 'Witnessed passages',
      witnessTurn: 'Turn',
      witnessText: 'Passage',
      witnessBy: 'Witnessed by',
      witnessPending: 'Witnesses pending narrative record: turns {turns}',
      witnessFailed: 'Narrative recording failed for {range}: {reason}',
      observations: 'Observations',
      memoryProgress: 'through turn {count}',
    },
    timeline: {
      positions: 'Positions',
      placePeople: ': {people}',
      events: 'Events',
      audience: 'Witnessed by',
      moves: 'Moves',
      timeChange: 'Story time',
      transfers: 'Item transfers',
      kinds: { move: 'Move', time: 'Story time', transfer: 'Item transfer', witness: 'Witnessed' },
      items: 'Items',
      item: 'Item',
      holder: 'Holder',
      place: 'Location',
      unheld: 'Unheld',
    },
    director: {
      on: 'Director on',
      off: 'Director off',
      unknown: 'Director not recorded',
      revision: 'Revision {revision}',
      latest: 'Latest guidance',
      directionStatus: 'Status',
      basis: 'Based on',
      validThrough: 'Valid through',
      guidanceId: 'Guidance',
      deliveries: 'Per-turn delivery',
      deliveriesHint: 'Passed to writer is judged only from the saved injection record; prose cannot prove the model adopted it.',
      turn: 'Turn',
      delivery: 'Delivery',
      passedWriter: 'Passed to writer',
      reason: 'Reason',
      yes: 'Yes',
      no: 'No',
      notRecorded: 'Not recorded',
      hashPending: 'Checking',
      hashFailed: 'Cannot compute',
      hashFailedHint: 'This browser cannot compute the preference hash (it needs HTTPS or localhost), so whether guidance is usable is unknown.',
      statuses: {
        disabled: 'Off',
        pending: 'Preparing',
        ready: 'Ready',
        unavailable: 'No guidance',
        available: 'Available',
        expired: 'Expired',
        not_ready: 'Not ready',
        injected_direction: 'Injected',
      },
      statusHints: {
        disabled: 'Off: no call and no injection.',
        pending: 'Preparing guidance in the background; prose does not wait.',
        ready: 'Direction is available.',
        unavailable: 'No guidance is available.',
        available: 'Available for this stage.',
        expired: 'Shown for reference only; no longer injected.',
        not_ready: 'Not injected: guidance was not ready.',
        injected_direction: 'Stage direction injected.',
      },
      reasons: {
        director_disabled: 'Off: no call and no injection.',
        guidance_pending: 'Preparing guidance in the background; prose does not wait.',
        guidance_unavailable: 'No guidance is available.',
        guidance_expired: 'Shown for reference only; no longer injected.',
        recording_pending: 'The prose record is still being prepared in the background.',
        director_revision_changed: 'The Director settings revision changed.',
        preferences_changed: 'The out-of-character preferences changed.',
        phase_direction: 'The stage direction was included.',
      },
    },
    preferences: {
      title: 'Out-of-character preferences',
      kinds: { pace: 'Pace', focus: 'Character focus', direction: 'Direction', expectation: 'Out-of-character expectation' },
      scopes: { branch: 'This playthrough', next_4_turns: 'Next four turns' },
      sources: { explicit_ui: 'set by the player', explicit_ooc_expectation: 'written by the player' },
      paces: { linger: 'Linger', follow: 'Follow the player', advance: 'Move ahead' },
    },
    story: {
      title: 'Story record',
      turnCount: '{count} turns',
      opening: 'Opening',
      narrator: 'Narrator',
      playerInput: 'Player input',
      channels: { narration: 'Narration', dialogue: 'Dialogue', action: 'Action' },
      metadataPending: 'Awaiting record',
      audience: 'Witnessed by: {names}',
      generating: 'A turn is generating; its live draft exists only in the play process and is not visible here.',
    },
    sources: {
      evidence: 'Evidence {count}',
      evidenceLabel: 'Evidence sources',
      missing: 'Source text is not saved',
      range: 'Turns {from}–{through}',
      turn: 'Turn {count}',
      kinds: { opening: 'Opening', author_fact: 'Authored opening fact', event: 'Recorded event', turn: 'Story turn', unknown: 'Saved evidence' },
    },
    memoryKinds: {
      observed: 'Observed',
      reported: 'Reported',
      belief: 'Belief',
      interpretation: 'Interpretation',
      correction: 'Memory correction',
      conflict: 'Memory conflict',
      record: 'Memory record',
    },
    calls: {
      title: 'Model calls',
      count: '{count} calls',
      totalCost: 'Total cost {cost}',
      failedCount: '{count} failed',
      time: 'Time',
      source: 'Source',
      role: 'Role',
      model: 'Model · provider',
      status: 'Status',
      ttft: 'First token',
      duration: 'Duration',
      tokens: 'Tokens in / out',
      cost: 'Cost',
      expand: 'Show request body and output',
      sourceRequest: 'Request',
      sourceJob: 'Background job',
      sourceOther: 'Other',
      statuses: { ok: 'OK', error: 'Error', aborted: 'Aborted' },
      callId: 'Call',
      authNotRecorded: 'auth headers and environment variables are never recorded',
      requestBody: 'Request body',
      messageCount: '{count} messages',
      chars: '{count} chars',
      output: 'Output',
      reasoning: 'Reasoning',
      finishReason: 'Finish reason',
      protocol: 'Protocol',
      unavailable: 'Not available in the platform audit',
    },
    drama: {
      title: 'Avatar performances',
      hint: 'One performance per turn; points are reserved at start and refunded if it fails before the first frame.',
      time: 'Started',
      person: 'Character and state',
      duration: 'Duration',
      firstFrame: 'First frame',
      result: 'Result',
      points: 'Points',
      refund: 'Refund',
      refunded: 'Refunded',
      refundedTotal: '{points} pts refunded',
      count: '{count} performances',
      empty: 'No avatar performances in this run.',
      statuses: { starting: 'Starting', live: 'Performing', ended: 'Ended' },
      reasons: { completed: 'Completed', cancelled_during_start: 'Cancelled while starting', disconnected: 'Disconnected', start_failed: 'Failed to start', playback_failed: 'Playback failed', hidden: 'Page hidden', switched_off: 'Switched off', unmounted: 'Left the page', turn_cancelled: 'Turn cancelled', replaced: 'Replaced by a new performance', browser_disconnected: 'Control connection lost', expired: 'Time limit reached', interrupted: 'Interrupted by a server restart' },
    },
    jobs: {
      title: 'Background jobs',
      kind: 'Type',
      range: 'Turns',
      status: 'Status',
      attempts: 'Attempts',
      nextRetry: 'Next retry',
      error: 'Error',
      retry: 'Retry',
      retried: '{count} job(s) queued for retry',
      trigger: 'Trigger: {trigger}',
      completed: 'Completed: {time}',
      kinds: { narrative_record: 'Record turn', memory: 'Memory', director: 'Director', suggestions: 'Suggestions' },
      triggers: { cadence: 'Routine every four turns', enabled: 'Director switched on', preference_changed: 'Preferences changed', forked: 'Branch forked' },
      statuses: { pending: 'Pending', completed: 'Completed', failed: 'Failed', superseded: 'Superseded' },
    },
    requests: { title: 'Turn requests', time: 'Started', turn: 'Turn', input: 'Input', status: 'Status', error: 'Error', elapsed: 'Elapsed', points: 'Points', id: 'ID', diagnostics: 'Validation feedback', diagnosticsCount: '{count} items', diagnosticsExpand: 'Show {count} validation feedback items' },
    diagnostics: {
      raw: 'Model output · {count} chars',
      kinds: {
        narrative_format: 'Format check',
        narrative_preamble: 'Text before the story',
        narrative_tag_normalization: 'Tag normalization',
        narrative_recording: 'Story recording',
        narrative_continuity: 'Continuity review',
        memory_owner_failure: 'Memory owner failure',
      },
    },
    errors: {
      unknown: 'Unclassified error',
      internal_error: 'Internal server error',
      interrupted: 'Interrupted by a service restart',
      cancelled: 'Cancelled',
      insufficient_balance: 'Insufficient points balance',
      stale_turn: 'The save changed before this turn finished',
      busy: 'Another request was in progress',
      run_archived: 'The run is archived',
      invalid_data: 'Invalid data',
      content_filter: 'Blocked by the content filter',
      model_output_limit: 'Model output hit the length limit',
      model_response_blocked: 'The model refused or safety policy blocked the response',
      incomplete_model_output: 'Model output was incomplete',
      model_not_configured: 'No model is configured for this stage',
      context_limit: 'Context exceeds the model limit',
      invalid_structured_json: 'Structured output could not be parsed',
      invalid_narrative_format: 'Writer prose format is invalid',
      invalid_performance: 'Writer character or scene setup is invalid',
      invalid_performance_states: 'Writer state output is invalid',
      missing_narrative_tags: 'Prose is missing speaker tags',
      invalid_speaker: 'Invalid speaker',
      invalid_narrative_record: 'Narrative record output is invalid',
      narrative_recording_failed: 'Narrative recording failed',
      narrative_record_gap: 'Earlier turns are not recorded yet',
      invalid_story_time: 'Invalid story time',
      invalid_item_transfer: 'Invalid item transfer',
      invalid_scene_location: 'Invalid scene location',
      invalid_scene_path: 'Invalid movement path',
      source_conflict: 'Evidence sources conflict',
      memory_too_long: 'Memory summary is too long',
      memory_source_too_large: 'Too much source material for one memory job',
      memory_context_limit: 'Memory context exceeds the model limit',
      memory_backlog_waiting: 'Waiting for earlier memory jobs',
      invalid_correction: 'Invalid memory correction',
      unsupported_correction: 'Unsupported memory correction',
      invalid_player_suggestions: 'Reply suggestion output is invalid',
      invalid_preference: 'Invalid preference',
      job_conflict: 'Conflicting job',
      package_integrity_failed: 'Work content failed its integrity check',
    },
    raw: {
      title: 'Raw data',
      pack: 'Work content',
      snapshot: 'Full snapshot',
      requests: 'Request records',
      contextNote: 'context_records are runtime context snapshots; only the request bodies in the Calls tab are what was sent to the model.',
    },
  },
}

export const novelRunsZh = {
  title: '小说对局',
  list: {
    filters: { email: '玩家邮箱', emailPlaceholder: '按邮箱搜索', pack: '作品', packSearch: '全部作品（输入标题、短链名或创作者邮箱搜索）', packSearching: '搜索中…', packEmpty: '没有匹配的作品', packClear: '清除作品筛选', failedOnly: '只看有失败任务', apply: '搜索' },
    table: { player: '玩家', pack: '作品', status: '状态', turns: '回合数', jobs: '后台任务', failedJobs: '失败任务', lastPlayed: '最后游玩', actions: '操作' },
    statuses: { active: '进行中', archived: '已归档' },
    jobsPending: '有待办',
    jobsIdle: '无',
    unknownUser: '未知玩家',
    empty: '没有符合条件的对局',
    audit: '审计',
    filterByPack: '只看这部作品的对局',
    pager: { prev: '上一页', next: '下一页', pageSize: '每页条数', summary: '共 {total} 局 · 第 {page} / {pages} 页' },
  },
  audit: {
    back: '对局列表',
    refresh: '刷新',
    empty: '暂无',
    copy: '复制',
    copied: '已复制',
    copyFailed: '复制失败：{message}',
    copyId: '复制 {id}',
    points: '{points} 积分',
    separator: '、',
    spoilerNotice: '含剧透 · 作者视图：展示隐藏设定、人物知情范围、实际提示词和模型输出，请勿与玩家共享。',
    tabs: { overview: '概览', characters: '人物', timeline: '时间线', director: '导演', story: '剧情', calls: '调用', drama: '数字人', raw: '原始数据' },
    bar: {
      turns: '第 {count} 轮',
      jobsPending: '后台任务 待办',
      jobsIdle: '后台任务 空闲',
      writer: '写作 {model}',
      writerTitle: '本次游玩的写作模式：{performer}；最近实际模型：{model}',
      points: '累计 {points} 积分',
      refreshTitle: '最近刷新 {time}。只读，打开本页不会触发模型调用。',
      retryFailed: '重试失败任务（{count}）',
    },
    overview: { runInfo: '对局信息', player: '玩家', work: '作品', packageHash: '内容哈希', created: '创建', lastPlayed: '最后游玩', branch: '分支' },
    branch: { active: '当前', candidate: '候选', option: '{id} · {state} · {turns} 回合' },
    scene: {
      title: '当前场景',
      people: '在场人物',
      storyTime: '故事时间',
      items: '此处物品',
      recording: {
        pending: '正文已保存；场景与人物见闻在后台更新。',
        failed: '正文已保存，后台记录失败，可在"调用"页签的后台任务里重试。',
      },
    },
    request: {
      title: '最近一次请求',
      input: '输入',
      status: '状态',
      elapsed: '耗时',
      cost: '成本',
      stage: '阶段',
      model: '模型',
      unrecorded: '这条请求没有保存模型阶段记录，不会从模板补造。',
    },
    roles: { performer: '写作者', structured: '结构化' },
    time: {
      day: '第 {day} 天',
      phases: { morning: '清晨', afternoon: '下午', evening: '傍晚', night: '夜晚' },
    },
    requestStatuses: { generating: '生成中', committed: '已提交', failed: '失败', cancelled: '已取消' },
    stageStatuses: { started: '进行中', completed: '已完成', failed: '失败' },
    turns: {
      turn: '第 {seq} 回合',
      modes: { mixed: '对白加动作', speech: '对白', action: '动作', continue: '继续' },
      recordingStates: { pending: '待记录', completed: '已记录', failed: '记录失败' },
    },
    characters: {
      list: '人物',
      openCount: '{count} 项未完成',
      appearance: '外貌',
      identity: '身份',
      initialGoal: '初始目标',
      latestGoal: '最近目标',
      sections: { opening: '开局设定', later: '后续记录', witness: '见闻与观察', memory: '滚动记忆' },
      facts: '知情事实',
      relations: '关系',
      portrayal: '性格与口吻',
      personality: '性格与驱动力',
      speechStyle: '口吻',
      cues: '演出线索',
      examples: '口吻示例（非历史）',
      attitude: '态度',
      goals: '目标',
      threads: '未完成事项',
      thread: '事项',
      witnessed: '见闻段落',
      witnessTurn: '轮次',
      witnessText: '段落摘要',
      witnessBy: '见闻者',
      witnessPending: '见闻待剧情记录：第 {turns} 轮',
      witnessFailed: '{range}剧情记录失败：{reason}',
      observations: '观察',
      memoryProgress: '已处理至第 {count} 轮',
    },
    timeline: {
      positions: '位置分布',
      placePeople: '：{people}',
      events: '事件',
      audience: '见闻者',
      moves: '移动',
      timeChange: '故事时间',
      transfers: '物品转移',
      kinds: { move: '移动', time: '时间', transfer: '转移', witness: '见闻' },
      items: '物品',
      item: '物品',
      holder: '持有者',
      place: '位置',
      unheld: '无人持有',
    },
    director: {
      on: '导演已开启',
      off: '导演已关闭',
      unknown: '导演未记录',
      revision: '修订 {revision}',
      latest: '最新建议',
      directionStatus: '状态',
      basis: '依据',
      validThrough: '有效至',
      guidanceId: '建议',
      deliveries: '逐轮投递',
      deliveriesHint: '“传给写作者”只据该轮保存的注入记录判断；正文不能证明模型采用了建议。',
      turn: '轮次',
      delivery: '交付状态',
      passedWriter: '传给写作者',
      reason: '原因',
      yes: '是',
      no: '否',
      notRecorded: '未记录',
      hashPending: '计算中',
      hashFailed: '无法计算',
      hashFailedHint: '浏览器算不出偏好哈希（需要 HTTPS 或 localhost），无法判断建议是否可用。',
      statuses: {
        disabled: '已关闭',
        pending: '准备中',
        ready: '可用',
        unavailable: '暂无建议',
        available: '可用',
        expired: '已过期',
        not_ready: '未就绪',
        injected_direction: '已注入',
      },
      statusHints: {
        disabled: '已关闭：不调用，也不注入。',
        pending: '后台正在准备建议；正文不会等待。',
        ready: '方向可用。',
        unavailable: '暂无可用建议。',
        available: '可用于当前阶段。',
        expired: '只保留显示，已不再注入。',
        not_ready: '未注入：建议尚未就绪。',
        injected_direction: '已注入阶段方向。',
      },
      reasons: {
        director_disabled: '已关闭：不调用，也不注入。',
        guidance_pending: '后台正在准备建议；正文不会等待。',
        guidance_unavailable: '暂无可用建议。',
        guidance_expired: '只保留显示，已不再注入。',
        recording_pending: '正文记录仍在后台整理。',
        director_revision_changed: '导演设置修订已变化。',
        preferences_changed: '场外偏好已变化。',
        phase_direction: '已传入阶段方向。',
      },
    },
    preferences: {
      title: '场外偏好',
      kinds: { pace: '节奏', focus: '关注人物', direction: '体验方向', expectation: '场外游玩期待' },
      scopes: { branch: '本次游玩', next_4_turns: '接下来四轮' },
      sources: { explicit_ui: '玩家明确设置', explicit_ooc_expectation: '玩家明确填写' },
      paces: { linger: '放慢细品', follow: '跟随玩家', advance: '推进剧情' },
    },
    story: {
      title: '剧情记录',
      turnCount: '{count} 回合',
      opening: '开场',
      narrator: '旁白',
      playerInput: '玩家输入',
      channels: { narration: '旁白', dialogue: '对白', action: '动作' },
      metadataPending: '等待记录',
      audience: '见闻者：{names}',
      generating: '有回合正在生成；生成中的临时预览只在游玩进程内存里，后台看不到。',
    },
    sources: {
      evidence: '证据 {count}',
      evidenceLabel: '证据来源',
      missing: '来源正文未保存',
      range: '第 {from}–{through} 轮',
      turn: '第 {count} 轮',
      kinds: { opening: '开场', author_fact: '作者开局事实', event: '已记录事件', turn: '剧情轮次', unknown: '已保存证据' },
    },
    memoryKinds: { observed: '观察', reported: '转述', belief: '认知／相信', interpretation: '解释', correction: '记忆更正', conflict: '记忆冲突', record: '记忆记录' },
    calls: {
      title: '模型调用',
      count: '调用 {count} 次',
      totalCost: '总成本 {cost}',
      failedCount: '失败 {count} 次',
      time: '时间',
      source: '来源',
      role: '角色',
      model: '模型 · 供应商',
      status: '状态',
      ttft: '首字',
      duration: '耗时',
      tokens: 'tokens 入 / 出',
      cost: '成本',
      expand: '展开请求正文与输出',
      sourceRequest: '回合请求',
      sourceJob: '后台任务',
      sourceOther: '其他',
      statuses: { ok: '成功', error: '出错', aborted: '中止' },
      callId: '调用',
      authNotRecorded: '请求认证头和环境变量不会被记录',
      requestBody: '请求正文',
      messageCount: '{count} 条消息',
      chars: '{count} 字',
      output: '模型输出',
      reasoning: '推理',
      finishReason: '结束原因',
      protocol: '协议',
      unavailable: '平台审计里没有这部分',
    },
    drama: {
      title: '数字人演出',
      hint: '一回合一场；开场时预扣积分，首帧之前失败自动退还。',
      time: '开始',
      person: '人物与状态',
      duration: '时长',
      firstFrame: '首帧耗时',
      result: '结果',
      points: '积分',
      refund: '退款',
      refunded: '已退款',
      refundedTotal: '已退 {points} 积分',
      count: '{count} 场',
      empty: '这一局没有数字人演出。',
      statuses: { starting: '连接中', live: '演出中', ended: '已结束' },
      reasons: { completed: '演完', cancelled_during_start: '开场时取消', disconnected: '连接断开', start_failed: '启动失败', playback_failed: '播放失败', hidden: '页面隐藏', switched_off: '关闭开关', unmounted: '离开页面', turn_cancelled: '回合取消', replaced: '被新一场替换', browser_disconnected: '控制连接断开', expired: '达到时长上限', interrupted: '服务重启中断' },
    },
    jobs: {
      title: '后台任务',
      kind: '类型',
      range: '轮次',
      status: '状态',
      attempts: '尝试',
      nextRetry: '下次重试',
      error: '错误',
      retry: '重试',
      retried: '已排队重试 {count} 个任务',
      trigger: '触发原因：{trigger}',
      completed: '完成时间：{time}',
      kinds: { narrative_record: '记录回合', memory: '记忆', director: '导演', suggestions: '建议' },
      triggers: { cadence: '每四轮例行', enabled: '导演开启', preference_changed: '偏好变化', forked: '分支分叉' },
      statuses: { pending: '待执行', completed: '已完成', failed: '失败', superseded: '已作废' },
    },
    requests: { title: '回合请求', time: '开始', turn: '回合', input: '输入', status: '状态', error: '错误', elapsed: '耗时', points: '积分', id: 'ID', diagnostics: '校验反馈', diagnosticsCount: '{count} 条', diagnosticsExpand: '展开 {count} 条校验反馈' },
    diagnostics: {
      raw: '模型原文 · {count} 字',
      kinds: {
        narrative_format: '格式校验',
        narrative_preamble: '正文前的多余文字',
        narrative_tag_normalization: '标签规范化',
        narrative_recording: '剧情记录',
        narrative_continuity: '连贯性审查',
        memory_owner_failure: '记忆整理失败',
      },
    },
    errors: {
      unknown: '未归类错误',
      internal_error: '服务内部错误',
      interrupted: '服务重启导致中断',
      cancelled: '已取消',
      insufficient_balance: '积分余额不足',
      stale_turn: '回合完成前存档已变化',
      busy: '已有请求在进行',
      run_archived: '对局已归档',
      invalid_data: '数据无效',
      content_filter: '被内容过滤拦截',
      model_output_limit: '模型输出达到长度上限',
      model_response_blocked: '模型拒绝或被安全策略拦截',
      incomplete_model_output: '模型输出不完整',
      model_not_configured: '这个阶段没有配置模型',
      context_limit: '上下文超出模型上限',
      invalid_structured_json: '结构化输出无法解析',
      invalid_narrative_format: '正文格式无效',
      invalid_performance: '人物或场景设置无效',
      invalid_performance_states: '写作状态输出无效',
      missing_narrative_tags: '正文缺少说话人标记',
      invalid_speaker: '说话人无效',
      invalid_narrative_record: '剧情记录输出无效',
      narrative_recording_failed: '剧情记录失败',
      narrative_record_gap: '前面的回合尚未记录',
      invalid_story_time: '故事时间无效',
      invalid_item_transfer: '物品转移无效',
      invalid_scene_location: '场景地点无效',
      invalid_scene_path: '移动路径无效',
      source_conflict: '证据来源冲突',
      memory_too_long: '记忆摘要过长',
      memory_source_too_large: '单次记忆整理的材料过多',
      memory_context_limit: '记忆整理上下文超出模型上限',
      memory_backlog_waiting: '等待前序记忆整理',
      invalid_correction: '记忆更正无效',
      unsupported_correction: '不支持的记忆更正',
      invalid_player_suggestions: '回应建议输出无效',
      invalid_preference: '偏好无效',
      job_conflict: '任务冲突',
      package_integrity_failed: '作品内容完整性校验失败',
    },
    raw: {
      title: '原始数据',
      pack: '作品内容',
      snapshot: '完整快照',
      requests: '请求记录',
      contextNote: 'context_records 是运行时上下文快照；只有"调用"页签里的请求正文才是实际发给模型的内容。',
    },
  },
}
